import { render, staticRenderFns } from "./secondMarketing.vue?vue&type=template&id=0695e138&scoped=true"
import script from "./secondMarketing.vue?vue&type=script&lang=js"
export * from "./secondMarketing.vue?vue&type=script&lang=js"
import style0 from "./secondMarketing.vue?vue&type=style&index=0&id=0695e138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0695e138",
  null
  
)

export default component.exports